<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>Request Credits</h2>
      <button class="close" @click="closeModal">×</button>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-12 mb-2">
          <p>
            You can request additional credits at any time.
            <a href="#" @click="showCommentField = true">Add a message</a> to
            ask questions or include additional details or simply click send and
            we’ll be touch to help you make sure your users are covered.
          </p>
        </div>
        <div class="col-12">
          <button
            class="collapse-trigger"
            :class="{ hide: showCommentField }"
            @click="showCommentField = true"
          >
            <font-awesome-icon
              class="icon alt"
              :icon="['fas', 'plus-circle']"
            />
            Add Message
          </button>
          <div class="collapse" :class="{ show: showCommentField }">
            <form-component>
              <input-text-area
                id="comment"
                v-model="comment"
                name="comment"
                label="Your Message (optional)"
                type="text"
                maxlength="500"
              />
              <span class="limiter">{{ charCount }}</span>
            </form-component>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button type="button" @click="closeModal">Cancel</button>
      <button
        class="primary"
        type="button"
        :disabled="submitting"
        @click="submit"
      >
        <font-awesome-icon
          v-if="submitting"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Send</span>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import AdminClient from '@/api/AdminClient';
import FormComponent from '@/components/FormComponent.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';

export default Vue.extend({
  name: 'RequestCreditsModal',

  components: {
    FormComponent,
    InputTextArea
  },

  inject: ['collegeDetailsReport'],

  data() {
    return {
      adminClient: new AdminClient(this.$http),

      submitting: false,

      showCommentField: false,
      comment: ''
    };
  },

  computed: {
    charCount() {
      const limit = 500;
      const len = this.comment.length;

      return `${limit - len} / ${limit} characters remaining`;
    }
  },

  methods: {
    closeModal() {
      this.$modal.close();
    },

    async submit() {
      this.submitting = true;

      try {
        await this.adminClient.requestCreditsForSchool(
          this.collegeDetailsReport.schoolId,
          this.comment
        );
        this.$store.commit('setGlobalAlert', {
          msg: 'Your request for credits was submitted!'
        });
      } catch (e) {
        this.$store.commit('setGlobalAlert', {
          msg: 'There was an error requesting credits. Please try again!',
          error: true
        });
      }

      this.closeModal();
      this.submitting = false;
      this.showCommentField = false;
    }
  }
});
</script>

<style lang="scss" scoped>
.limiter {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: 15px;
  font-style: italic;
  margin-bottom: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.a11y-modal {
  ::v-deep .form .form__input {
    label {
      text-transform: none;
      font-size: 15px;
      letter-spacing: 0;
      margin-bottom: 0.5rem;
      font-weight: 500;
    }
    textarea {
      min-height: 100px;
      border: solid 1px #d1d1d1;
      background: #fff;
      color: inherit;
      margin-bottom: 0;
      resize: none;

      &:focus {
        color: inherit;
        border: solid 1px $dark-blue;
        background: #f8f8f8;
      }
    }
  }
}

.collapse-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 44px;
  overflow: hidden;
  opacity: 1;
  width: auto;
  border: none;
  background: #e4e4e4;
  border-radius: 4px;
  height: 38px;
  padding: 0 16px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  svg {
    margin-right: 8px;
  }

  &.hide {
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    border-top-width: 0;
    border-bottom-width: 0;
    opacity: 0;
  }

  &:hover,
  &:focus {
    box-shadow: inset 0px 0px 0px 1px #6b6e88;
    background: #f5f5f5;
  }

  &:active {
    background: #e0e0e0;
  }
}
.collapse {
  display: block;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  &.show {
    max-height: 350px;
    opacity: 1;
  }
}
</style>
